import { useAppState } from "AppState";
import PanelLayout from "components/common/PanelLayout/PanelLayout";
import { TabletDataContext } from "components/Gates/TabletDataGate";
import { shouldHideUsageType } from "components/UsageTypeSelector/utils";

import React, { FunctionComponent, useContext } from "react";
import OnboardingContainer from "screens/Onboarding/Onboarding.container";
import CustomerPersonalInfoEditor from "screens/Onboarding/SignUp/CustomerPersonalInfo/CustomerPersonalInfoEditor";
import useReactRouter from "use-react-router";
import { Container, WidgetWrapper } from "./common/TabbedContainers";
import EditProfileTabs, { EditProfileTabNames } from "./tabs/EditProfileTabs";

const EditCustomerPersonalInfo: FunctionComponent = () => {
  const { history, location } = useReactRouter();
  const tabletData = useContext(TabletDataContext);
  const onboarding = OnboardingContainer.useContainer();
  // TODO: Use <Lodaing /> component
  const { customer, loadingCustomer } = onboarding.getCustomerByAuthToken();
  const {
    updateCustomerProfile,
    error,
    completed,
    loading
  } = onboarding.updateCustomerProfile();
  const { locationName } = useAppState();
  return (
    <PanelLayout
      title={locationName}
      titleSecondary="Edit Profile"
      closeButtonHandler
    >
      <Container>
        <EditProfileTabs
          hideUsageTypeTab={shouldHideUsageType(tabletData)}
          hasNoInterests={tabletData && tabletData.hasNoInterests}
          walletStatus={location.state.walletStatus}
          history={history}
          currentTab={EditProfileTabNames.CustomerPersonalInfo}
        />
        <WidgetWrapper enlarged transparent>
          {loadingCustomer ? (
            ""
          ) : (
            <CustomerPersonalInfoEditor
              completed={completed}
              currentCustomer={customer}
              onSubmit={updateCustomerProfile}
              error={error}
              submitButtonText="Update"
              loading={loading}
            />
          )}
        </WidgetWrapper>
      </Container>
    </PanelLayout>
  );
};

export default EditCustomerPersonalInfo;



// WEBPACK FOOTER //
// ./src/screens/Main/edit-profile/EditCustomerPersonalInfo.tsx